import React, { useState, useRef } from 'react';

const Suggestions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const formRef = useRef(null);
  const scriptUrl =
    'https://script.google.com/macros/s/AKfycbzQeiCl3MxRppNIoyGCc7atcMyNNPaNbsARjLmqHoEQb7L3--gA2zegUfifK9I3BxKR/exec';
  const [loading, setLoading] = useState(false);

  const togglePopup = () => setIsOpen(!isOpen);

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);

    fetch(scriptUrl, {
      method: 'POST',
      body: new FormData(formRef.current),
    })
      .then(() => {
        console.log('SUCCESSFULLY SUBMITTED');
        setLoading(false);
        togglePopup();
      })
      .catch(err => console.error(err));
  };

  return (
    <>
      <button
        className="bg-sky-950 text-white px-4 py-2 rounded"
        onClick={togglePopup}
      >
        Feedback Form
      </button>

      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-20">
          <div className="bg-white p-6 rounded shadow-lg m-5 max-w-md w-full">
            <h2 className="text-2xl mb-4">Feedback Form</h2>
            <h3 className="text-lg mb-4">
              If you have any feedback about this webapp, please let us know.
            </h3>

            <form ref={formRef} onSubmit={handleSubmit} name="google-sheet">
              <div className="mb-4">
                <label
                  htmlFor="first"
                  className="block text-gray-700 text-lg font-bold mb-2"
                >
                  Optional: First Name
                </label>
                <input
                  id="first"
                  name="first"
                  placeholder="First Name"
                  className="shadow border rounded w-full py-2 px-3 focus:outline-none"
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="last"
                  className="block text-gray-700 text-lg font-bold mb-2"
                >
                  Optional: Last Name
                </label>
                <input
                  id="last"
                  name="last"
                  placeholder="Last Name"
                  className="shadow border rounded w-full py-2 px-3 focus:outline-none"
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="feedback"
                  className="block text-gray-700 text-lg font-bold mb-2"
                >
                  Feedback
                </label>
                <textarea
                  id="feedback"
                  name="feedback"
                  required
                  placeholder="Your feedback…"
                  className="shadow border rounded w-full py-2 px-3 focus:outline-none"
                />
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                  {loading ? 'Loading…' : 'Submit'}
                </button>
                <button
                  type="button"
                  onClick={togglePopup}
                  className="ml-3 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Suggestions;
